export default "__VITE_ASSET__Cuk_VlNX__"